<ng-content [hidden]="!isInitialized()" />
